<ng-content [hidden]="!isInitialized()" />
